// Codifica una stringa UTF-8 in Base64
export const btoaUtf8 = (str: string): string =>
  btoa(String.fromCharCode(...new TextEncoder().encode(str)));

// Decodifica da Base64 a stringa UTF-8
export const atobUtf8 = (base64: string): string =>
  new TextDecoder().decode(Uint8Array.from(atob(base64), c => c.charCodeAt(0)));

export const toBase64 = (str: string): string => {
  const bytes = new TextEncoder().encode(str);
  const chunkSize = 0x8000;
  let binary = '';

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...chunk);
  }

  return btoa(binary);
};
